import { type BudgetPeriod, PERIOD_OWNS } from "./period.ts";

export type Stopped = { how: string; period?: BudgetPeriod | null; by?: string | null };

export function whyItStopped(stop: Stopped, named: string): string {
  if (stop.how === "halted") {
    return stop.by ? `${named} was stopped by ${stop.by}.` : `${named} was stopped.`;
  }
  if (stop.how === "refused")
    return `${named} could not answer: the provider rejected the key for this agent.`;

  if (stop.how === "spent")
    return `${named} stopped after the step that crossed the cap: ${PERIOD_OWNS[stop.period ?? "day"]} budget is reached.`;
  if (stop.how === "looped")
    return `${named} did not answer: agents were answering each other, so the chain was stopped.`;

  if (stop.how === "vanished")
    return `${named} did not answer: the worker that had this turn stopped before it finished.`;
  if (stop.how === "tooled") return `${named} did not answer: this turn reached the 200-tool safety limit.`;
  return `${named} could not answer, and it was not the key or the budget.`;
}
